// Функция очистки лишних хтмл атрибутов

export const allowedTagsDefault = ['div', 'p', 'span', 'a', 'b', 'i', 'img']

export function cleanHtml(htmlString:any, allowedTags:any = allowedTagsDefault) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  function cleanNode(node:any) {
    if (node.nodeType === 1) { // элемент
      // Проверяем, разрешен ли тег
      if (!allowedTags.includes(node.tagName.toLowerCase())) {
        node.remove();
        return;
      }
      // Удаляем все атрибуты, кроме class и style
      [...node.attributes].forEach(attr => {
        if (
          attr.name !== 'class' && 
          attr.name !== 'style' && 
          attr.name !== 'src' && 
          attr.name !== 'href' && 
          attr.name !== 'target'
        ) {
          node.removeAttribute(attr.name);
        }
      });
      // Рекурсивно очищаем дочерние узлы
      [...node.childNodes].forEach((child:any) => cleanNode(child));
    }
  }

  [...doc.body.childNodes].forEach((node:any) => cleanNode(node));

  return doc.body.innerHTML;
}
